/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import type { Tutor } from '@/types/class.type'
// import Slider from 'react-slick'
import studentModuleIconUrl from '@/assets/svg/student-module.svg?url'
import testModuleIconUrl from '@/assets/svg/test-module.svg?url'
import { cn } from '@/lib/utils'
import { hoverPressable } from '@/utils/style'
import { ClassStatus } from '../constants'

export interface ModuleCardProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string
  title: string
  imageUrl?: string
  imageAlt?: string
  tutors?: string[]
  tutorsDetail?: Tutor[]
  moduleName?: string
  students?: number
  status?: string
  tests?: number
  active?: boolean
  as?: 'div' | 'button' | 'a'
  href?: string
  onSelect?: () => void
}

export const ModuleCard: React.FC<ModuleCardProps> = ({
  id,
  title,
  imageUrl,
  imageAlt = title,
  tutors,
  tutorsDetail,
  status,
  moduleName,
  students,
  tests,
  active,
  as = 'div',
  className,
  href,
  onSelect,
  ...rest
}) => {
  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   arrows: false,
  // }

  const validTutors = tutorsDetail?.filter((t) => t.image) || []
  const displayTutors = validTutors.slice(0, 4)

  const Component: any = as === 'a' ? 'a' : as === 'button' ? 'button' : 'div'
  return (
    <Component
      className={cn(
        'group relative flex flex-col rounded-lg border bg-white shadow-sm transition-colors',
        'border-[#EAECF0] hover:border-[#0057B8]/60',
        active && 'border-[#0057B8]',
        as === 'button' && 'text-left',
        `${hoverPressable}`,
        className
      )}
      href={Component === 'a' ? href : undefined}
      onClick={(e: React.MouseEvent) => {
        onSelect?.()
        rest.onClick?.(e as any)
      }}
      {...rest}
    >
      <div className='flex max-h-[250px] flex-col gap-3 p-3 pb-0'>
        <div className='relative aspect-295/180 w-full overflow-hidden rounded-lg'>
          {displayTutors.length === 0 ? (
            <div className='size-full bg-white' />
          ) : displayTutors.length === 1 ? (
            <img
              src={displayTutors[0].image || ''}
              alt={displayTutors[0].full_name}
              className='size-full object-cover transition-transform duration-300 group-hover:scale-[1.03]'
              loading='lazy'
            />
          ) : (
            <div className='grid size-full grid-cols-2 grid-rows-2'>
              {displayTutors.map((t, idx) => (
                <div
                  key={idx}
                  className={cn(
                    'overflow-hidden',
                    displayTutors.length === 2 && 'row-span-2', // 2 items: side-by-side full height
                    displayTutors.length === 3 && idx === 0 && 'row-span-2' // 3 items: first one spans full height left
                  )}
                >
                  <img
                    src={t.image || ''}
                    alt={t.full_name}
                    className='size-full object-cover transition-transform duration-300 group-hover:scale-[1.03]'
                    loading='lazy'
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className='flex flex-col gap-1 p-3 pt-0'>
        <div className='flex min-h-10 items-center gap-3'>
          <span className='line-clamp-2 text-sm font-light text-[#002652]'>
            {tutors?.join(', ') || ''}
          </span>
        </div>
        {moduleName && (
          <p className='line-clamp-2 max-h-15 min-h-15 text-[20px] font-normal text-[#002652]'>
            {/* {moduleName} */}
            {title}
          </p>
        )}
        {/* <p className='line-clamp-2 min-h-6 text-[14px] leading-snug text-[#002652]'>
          {title}
        </p> */}
        <div className='mt-2 flex gap-4 text-sm font-light text-[#667085]'>
          {typeof students === 'number' && (
            <span className='inline-flex items-center gap-2'>
              <img
                src={studentModuleIconUrl}
                alt='Students'
                className='size-5'
              />
              <span>
                {students} {students <= 1 ? 'student' : 'students'}
              </span>
            </span>
          )}
          {typeof tests === 'number' && (
            <span className='inline-flex items-center gap-2'>
              <img src={testModuleIconUrl} alt='Tests' className='size-5' />
              <span>
                {tests} {tests <= 1 ? 'test' : 'tests'}
              </span>
            </span>
          )}
        </div>
        <div
          className={cn(
            'flex items-center gap-1 text-xs capitalize',
            status === ClassStatus.active ? 'text-[#17B26A]' : 'text-[#F04438]'
          )}
        >
          <div
            className={cn(
              'size-1.5 rounded-full',
              status === ClassStatus.active ? 'bg-[#17B26A]' : 'bg-[#F04438]'
            )}
          ></div>
          {status}
        </div>
      </div>
    </Component>
  )
}

export default ModuleCard
